var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.571,
    height: 27.571,
    viewBox: "0 0 27.571 27.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wheel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M20.474,16.987A3.487,3.487,0,1,1,16.987,13.5,3.487,3.487,0,0,1,20.474,16.987Z",
    transform: "translate(-2.702 -2.702)",
    fill: "none",
    stroke: "#21a2ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M22.886,17.772a1.918,1.918,0,0,0,.384,2.115l.07.07a2.326,2.326,0,1,1-3.289,3.289l-.07-.07A1.933,1.933,0,0,0,16.7,24.548v.2a2.325,2.325,0,0,1-4.649,0v-.1A1.918,1.918,0,0,0,10.8,22.886a1.918,1.918,0,0,0-2.115.384l-.07.07A2.326,2.326,0,1,1,5.324,20.05l.07-.07A1.933,1.933,0,0,0,4.022,16.7h-.2a2.325,2.325,0,1,1,0-4.649h.1A1.918,1.918,0,0,0,5.684,10.8,1.918,1.918,0,0,0,5.3,8.683l-.07-.07A2.326,2.326,0,1,1,8.52,5.324l.07.07a1.918,1.918,0,0,0,2.115.384H10.8a1.918,1.918,0,0,0,1.162-1.755v-.2a2.325,2.325,0,1,1,4.649,0v.1A1.933,1.933,0,0,0,19.888,5.3l.07-.07A2.326,2.326,0,1,1,23.247,8.52l-.07.07a1.918,1.918,0,0,0-.384,2.115V10.8a1.918,1.918,0,0,0,1.755,1.162h.2a2.325,2.325,0,0,1,0,4.649h-.1a1.918,1.918,0,0,0-1.755,1.162Z",
    fill: "none",
    stroke: "#21a2ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.c8005537862f6ad92f325cdc5de6a0f2.svg";
export { ForwardRef as ReactComponent };